'use client';
import { useAuth } from '@bells/core/auth';
import { useLanguage } from '@bells/core/i18n';
import { authVerifySignin } from '@bells/i18n';
import { baseLocale } from '@bells/i18n/runtime';
import { LogIn } from 'lucide-react';
import Link from 'next/link';
import { Button } from '../../../components/button';

export const NavUser = () => {
  const { isAuthed } = useAuth();
  const { language } = useLanguage();

  if (isAuthed) {
    return null;
  }
  return (
    <Button
      size={'xs'}
      asChild
      className='hover:bg-brand hover:text-brand-foreground flex items-center gap-2 rounded-full bg-primary text-sm text-primary-foreground !opacity-100 transition-colors'
    >
      <Link
        prefetch={false}
        href={
          language == baseLocale
            ? `/auth/signin/customer`
            : `/${language}/auth/signin/customer`
        }
      >
        <LogIn />
        <span className='hidden md:block'>{authVerifySignin()}</span>
      </Link>
    </Button>
  );
};
